import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-690 (4.5 consent).
export const ConsentScreen = () => (
  <StubScreen id="consent" heading="Nur noch Ihre Einwilligung." />
);
